module.exports = __webpack_public_path__ + "img/logo17.854c3430.jpg";